// add in data 'statusInputOptions' to erase 'statusDefaultInputOptions'
import { isEmpty } from 'lodash'
import { mapGetters } from 'vuex'
import DefaultValues from './DefaultValues'

export default {
  mixins: [DefaultValues],
  data () {
    return {
      multiselection: false,
      selectedItems: [],
      statusDefaultInputOptions: {
        'available': 'Visible',
        'draft': 'Brouillon',
        'archived': 'Archivé'
      },
      lotInputOptions: {
        'available': 'Disponible',
        'draft': 'Brouillon'
      }
    }
  },
  computed: {
    ...mapGetters(['isManager', 'isSeller', 'isPromoteurMode', 'isDistributeurMode']),
    inputOptions () {
      return this.statusInputOptions || this.statusDefaultInputOptions
    },
    selectItemKey () {
      return 'pk'
    },
    selectItemArray () {
      return 'items'
    },
    programInputOptions () {
      let options = {
        'available': 'Visible',
        'draft': 'Brouillon',
        'archived': 'Archivé'
      }
      if (this.isDistributeurMode) {
        options['private'] = 'Privé'
      }
      return options
    }
  },
  methods: {
    afterChange () {
      return undefined
    },
    selectItem (v) {
      if (this.selectedItems.includes(v.data)) {
        const index = this.selectedItems.findIndex(x => x === v.data)
        this.selectedItems.splice(index, 1)
      } else {
        if (v.e && v.e.shiftKey) {
          const lastAdded = this.selectedItems[this.selectedItems.length - 1]
          const firstIndex = this[this.selectItemArray].findIndex(x => x[this.selectItemKey] === lastAdded)
          const lastIndex = this[this.selectItemArray].findIndex(x => x[this.selectItemKey] === v.data)
          return this[this.selectItemArray].slice(firstIndex, lastIndex + 1).forEach(x => {
            if (!isEmpty(this.checkAvailable)) {
              if (!this.selectedItems.includes(x[this.selectItemKey]) && this.checkAvailable.values.includes(x[this.checkAvailable.key])) {
                this.selectedItems.push(x[this.selectItemKey])
              }
            } else {
              if (!this.selectedItems.includes(x[this.selectItemKey])) {
                this.selectedItems.push(x[this.selectItemKey])
              }
            }
          })
        } else this.selectedItems.push(v.data)
      }
    },
    selectItemToggleAll (items) {
      if (this.selectedItems.length > 0) {
        this.clearSelectedItems()
      } else {
        this.selectItemAll(items)
      }
    },
    selectItemAll (items) {
      items.forEach((item) => {
        let id
        if (item.pk) {
          id = item.pk
        } else if (item.program) {
          id = item.program
        } else {
          console.log('Erreur : merci de définir un ID !')
          return false
        }
        this.selectItem({data: id})
      })
    },
    checkedItem (id) {
      return this.selectedItems.includes(id)
    },
    clearSelectedItems () {
      this.selectedItems = []
    },
    cancelMultiselect () {
      this.multiselection = !this.multiselection
      this.clearSelectedItems()
    },
    async changeStatusSelection () {
      const {value: status} = await this.$swal({
        title: 'Changement de statut',
        inputPlaceholder: 'Selectionnez un statut',
        confirmButtonText: 'Changer le statut',
        input: 'select',
        inputOptions: this.inputOptions,
        inputValidator: (value) => {
          return !value && 'Vous devez choisir un statut'
        }
      })
      if (status) {
        this.service.patchAll({pk: this.selectedItems}, {status}).then(() => {
          this.$notify({
            type: 'is-success',
            text: 'Le statut a été mis à jour.'
          })
          this.loadItems()
          this.multiselection = !this.multiselection
          this.clearSelectedItems()
          this.afterChange()
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du statut.'
          })
        })
      }
    },
    async changeProgramStatusSelection () {
      const {value: status} = await this.$swal({
        title: 'Changement de statut',
        inputPlaceholder: 'Selectionnez un statut',
        confirmButtonText: 'Changer le statut',
        input: 'select',
        inputOptions: this.programInputOptions,
        inputValidator: (value) => {
          return !value && 'Vous devez choisir un statut'
        }
      })
      if (status) {
        this.$api.programService.patchAll({pk: this.selectedItems}, {status}).then(() => {
          this.$notify({
            duration: 4000,
            type: 'is-info',
            text: 'Les programmes sont en cours de mise à jour. Il vous faudra recharger la page pour voir le changement de statut.'
          })
          // this.loadItems()
          this.multiselection = !this.multiselection
          this.clearSelectedItems()
          this.afterChange()
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du statut.'
          })
        })
      }
    },
    async changeLotStatusSelection () {
      const {value: status} = await this.$swal({
        title: 'Changement de statut',
        html: '<b>Seuls les lots avec un statut "Disponible" ou "Brouillon" seront modifiés.</b>',
        inputPlaceholder: 'Selectionnez un statut',
        confirmButtonText: 'Changer le statut',
        input: 'select',
        inputOptions: this.lotInputOptions,
        inputValidator: (value) => {
          return !value && 'Vous devez choisir un statut'
        }
      })
      if (status) {
        this.$api.lotService.patchAll({pk: this.selectedItems}, {status}).then(() => {
          this.$notify({
            duration: 4000,
            type: 'is-info',
            text: 'Les lots sont en cours de mise à jour. Il vous faudra recharger la page pour voir le changement de statut.'
          })
          // this.loadItems()
          this.multiselection = !this.multiselection
          this.clearSelectedItems()
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du status.'
          })
        })
      }
    }
  },
  created () {
    window.addEventListener('keydown', e => {
      if (this.isManager || this.isSeller) return
      if (e.keyCode === 16) {
        this.multiselection = true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/MultiSelectionMixin.js